/**
 * A JSON document, read-only — the old web's `JsonViewerDialog` body:
 * CodeMirror with the JSON grammar under `vscodeDark`, pretty-printed when the
 * text parses and shown as-is when it does not.
 */
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";

const EXTENSIONS = [json()];

export function formatJson(text: string): string {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    return text;
  }
}

export function JsonView({ text }: { text: string }) {
  return (
    <div className="json-view">
      <CodeMirror value={formatJson(text)} height="100%" extensions={EXTENSIONS} theme={vscodeDark} readOnly={true} className="json-view-cm" />
    </div>
  );
}
